import { backgroundSyncService } from './backgroundSyncService';

interface UserAction {
  action_type: 'click' | 'form_fill' | 'page_view' | 'form_submit' | 'error' | 'search';
  element_id?: string;
  page_path: string;
  duration?: number;
  metadata?: any;
  timestamp: string;
}

class BehaviorAnalyticsService {
  private sessionStart = Date.now();
  private pageStart = Date.now();
  private isEnabled = process.env.NODE_ENV !== 'production'; // Sadece dev'de aktif

  track(actionType: UserAction['action_type'], elementId?: string, metadata?: any) {
    if (!this.isEnabled) return;

    try {
      const action: UserAction = {
        action_type: actionType,
        element_id: elementId,
        page_path: window.location.pathname,
        duration: Date.now() - this.pageStart,
        metadata: metadata ? JSON.stringify(metadata) : null,
        timestamp: new Date().toISOString()
      };

      // Local storage'a kaydet, background sync ile gönder
      const stored = JSON.parse(localStorage.getItem('analytics_queue') || '[]');
      stored.push(action);
      if (stored.length > 100) stored.shift(); // Max 100 item
      localStorage.setItem('analytics_queue', JSON.stringify(stored));
    } catch (error) {
      // Analytics hatalarını console'a yazdırma
      if (process.env.NODE_ENV === 'development') {
        console.warn('Analytics tracking failed:', error);
      }
    }
  }

  // Mevcut component'lere kolay entegrasyon
  trackFormInteraction(formName: string, fieldName: string, action: 'focus' | 'blur' | 'change') {
    this.track('form_fill', `${formName}_${fieldName}`, { action, form: formName, field: fieldName });
  }

  trackButtonClick(buttonId: string, context?: any) {
    this.track('click', buttonId, context);
  }

  trackPageView(pagePath: string) {
    this.pageStart = Date.now();
    this.track('page_view', pagePath);
  }

  trackFormSubmit(formName: string, success: boolean, errors?: string[]) {
    this.track('form_submit', formName, { success, errors, duration: Date.now() - this.pageStart });
  }

  // Otomatik tracking setup
  setupAutoTracking() {
    // Button clicks
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'BUTTON' || target.closest('button')) {
        const button = target.tagName === 'BUTTON' ? target : target.closest('button');
        this.trackButtonClick(button?.id || button?.className || 'unknown_button');
      }
    });

    // Form interactions
    document.addEventListener('focusin', (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') {
        const form = target.closest('form');
        this.trackFormInteraction(
          form?.id || form?.className || 'unknown_form',
          target.id || target.name || 'unknown_field',
          'focus'
        );
      }
    });
  }

  disable() { this.isEnabled = false; }
  enable() { this.isEnabled = true; }
}

export const behaviorAnalyticsService = new BehaviorAnalyticsService();
